// extracted by mini-css-extract-plugin
export var avatar = "_oj-3";
export var avatarContainer = "_oj-2";
export var avatarSpacer = "_oj-5";
export var avatarSpacerContainer = "_oj-4";
export var avatarStackContainer = "_oj-1";
export var bubble = "_oj-0";
export var remainderBubble = "_oj-6";